import { publicVendor } from './client';

const requestWhitelistVendedor = codigoPromotor => publicVendor.get(`/v1/vendedor/whitelist/${codigoPromotor}`);

export { requestWhitelistVendedor };
